import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CertificationRequestInterface } from 'src/app/model/certifications/certification-request-interface';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { ProductVariantService } from 'src/app/services/dataServices/product-variant-service/product-variant.service';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { CertificationRequestService } from 'src/app/services/dataServices/certification-request/certification-request.service';

@Component({
    selector: 'app-version-certification-request-status',
    templateUrl: './version-certification-request-status.component.html',
    styleUrls: ['./version-certification-request-status.component.css'],
    standalone: false
})
export class VersionCertificationRequestStatusComponent implements OnInit {
    public certificationRequest: CertificationRequestInterface = {};

    constructor(
        private certificationRequestService: CertificationRequestService,
        private productService: ProductService,
        private productVariantService: ProductVariantService,
        private router: Router,
        private organisationService: OrganisationService,
        private dialogService: DialogService
    ) {}

    ngOnInit() {
        this.certificationRequestService
            .getCertificationRequestById(2)
            .then((certificationRequest: CertificationRequestInterface) => {
                this.certificationRequest = certificationRequest;
            });
    }

    public backToProductVariantScreen() {
        this.router.navigate([
            '/organisations/' +
                this.organisationService.activeItem.organisationId +
                '/products/' +
                this.productService.activeItem.id +
                '/variants/' +
                this.productVariantService.activeItem.id
        ]);
    }

    public cancelCertificationProcess() {
        this.dialogService
            .openConfirmDialog(
                'Zertifizierung abbrechen',
                'Nein',
                'Ja',
                'Wollen Sie diesen Zertifizierungsvorgang wirklich abbrechen?'
            )
            .subscribe((confirmed: boolean) => {
                if (confirmed) {
                    //PUT DELETION OF CERTIFICATION_REQUEST HERE (BACKEND_REQUEST)
                    this.router.navigate([
                        '/organisations/' +
                            this.organisationService.activeItem.organisationId +
                            '/products/' +
                            this.productService.activeItem.id +
                            '/variants/' +
                            this.productVariantService.activeItem.id
                    ]);
                }
            });
    }
}
